var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScalable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "M5.558 11.666H3.333c-.916 0-1.666.75-1.666 1.667v4.166c0 .459.375.834.833.834h3.058a.836.836 0 0 0 .834-.834v-5a.836.836 0 0 0-.834-.833Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "M11.108 8.333H8.883c-.916 0-1.666.75-1.666 1.667v7.5c0 .458.375.833.833.833h3.892a.836.836 0 0 0 .833-.833V10c0-.917-.742-1.667-1.667-1.667Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "M16.667 14.166h-2.225a.836.836 0 0 0-.834.833v2.5c0 .459.375.834.834.834H17.5a.836.836 0 0 0 .833-.834v-1.666c0-.917-.75-1.667-1.666-1.667Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "M12.508 4.041c.259-.258.359-.566.275-.833-.083-.267-.341-.458-.708-.517l-.8-.133c-.033 0-.108-.058-.125-.092l-.442-.883c-.333-.675-1.091-.675-1.425 0l-.441.883c-.009.034-.084.092-.117.092l-.8.133c-.367.059-.617.25-.708.517-.084.267.016.575.275.833l.616.625c.034.025.059.125.05.159l-.175.766c-.133.575.084.834.225.934.142.1.45.233.959-.067l.75-.442c.033-.025.141-.025.175 0l.741.442c.234.142.425.183.575.183.175 0 .3-.066.375-.116.142-.1.359-.359.225-.934l-.175-.766c-.008-.042.017-.134.05-.159l.625-.625Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(125.327 -.176 7.631) scale(7.02221 5.00159)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FE6A2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.067 3.446 8.161) scale(9.83206 6.30335)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FE6A2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(138.593 6.207 10.626) scale(5.41384 4.05467)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FE6A2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.83324 4.78289 -3.6103 -3.6483 12.285 1.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FE6A2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalable);
export default __webpack_public_path__ + "static/media/scalable.d4f44fb574384bd5bc08ec789f17d38c.svg";
export { ForwardRef as ReactComponent };